module.exports = __webpack_public_path__ + "static/media/audio_file_icon.84fbef72.svg";